import { motion } from "framer-motion";
import { Star, Seal, BookOpen } from "@phosphor-icons/react";

export const CertificateCard = ({ name, packageTitle, level, color = "#0ea5e9", date }) => {
  const today = date || new Date().toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" });
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.96 }} animate={{ opacity: 1, scale: 1 }}
      className="print-cert relative bg-white rounded-[2rem] overflow-hidden"
      style={{ border: `10px solid ${color}`, boxShadow: "0 20px 60px rgba(15,23,42,0.15)" }}
      data-print="certificate"
    >
      <div className="absolute inset-0 dot-grid opacity-20" />
      <div className="absolute inset-3 rounded-[1.5rem] pointer-events-none" style={{ border: `2px dashed ${color}66` }} />

      <div className="relative px-8 sm:px-16 py-14 text-center">
        <div className="flex items-center justify-center gap-2 mb-4">
          <span className="grid place-items-center w-12 h-12 rounded-2xl text-white" style={{ backgroundColor: color }}>
            <BookOpen size={26} weight="duotone" />
          </span>
          <span className="font-heading font-bold text-2xl text-ink">Reading Keeper</span>
        </div>

        <p className="font-body font-bold uppercase tracking-[0.35em] text-xs text-slate-700">Certificate of Achievement</p>

        <div className="flex items-center justify-center gap-1 my-5">
          {[0, 1, 2, 3, 4].map((i) => <Star key={i} size={22} weight="fill" style={{ color }} />)}
        </div>

        <p className="font-body text-slate-600">This certificate is proudly presented to</p>
        <h1 className="font-heading font-bold text-4xl sm:text-5xl tracking-tight mt-2 mb-4" style={{ color }} data-testid="cert-name">
          {name || "A Wonderful Reader"}
        </h1>

        <p className="font-body text-lg text-ink leading-relaxed max-w-xl mx-auto">
          for successfully completing every lesson in
        </p>
        <p className="font-heading font-bold text-2xl text-ink mt-2" data-testid="cert-package">
          {packageTitle} <span className="text-slate-600 font-body text-lg">({level})</span>
        </p>

        <div className="flex items-end justify-between mt-14 max-w-lg mx-auto">
          <div className="text-center">
            <p className="font-heading text-lg text-ink border-t-2 border-slate-900/30 pt-1 px-6">{today}</p>
            <p className="font-body text-xs font-semibold uppercase tracking-widest text-slate-600 mt-1">Date</p>
          </div>
          <div className="relative">
            <span className="grid place-items-center w-20 h-20 rounded-full text-white" style={{ backgroundColor: color }}>
              <Seal size={40} weight="duotone" />
            </span>
            <Star size={18} weight="fill" className="absolute -top-1 -right-1 text-brand-sun" />
          </div>
          <div className="text-center">
            <p className="font-heading text-lg text-ink border-t-2 border-slate-900/30 pt-1 px-6" style={{ fontFamily: "'Fredoka'" }}>Reading Keeper</p>
            <p className="font-body text-xs font-semibold uppercase tracking-widest text-slate-600 mt-1">Reading Coach</p>
          </div>
        </div>
      </div>
    </motion.div>
  );
};
